import {Box, Tooltip as MUITooltip, TooltipProps as MUITooltipProps} from '@mui/material';
import {useEffect, useState} from 'react';
import {useDetectTouchDevice} from '../../hooks/touch-device';
import {useLocation} from 'react-router-dom';
import {ScreenPaths} from '../../enums';

export interface TooltipProps extends MUITooltipProps {
  /** Put cursor(on hover) behaving as "unabled to edit" */
  notAllowedCursor?: boolean;
}

export function Tooltip({children, notAllowedCursor, className, sx, ...rest}: TooltipProps) {
  const isTouch = useDetectTouchDevice();
  let {pathname} = useLocation();
  const [open, setOpen] = useState(false);
  const [isDailyCareLogApp] = useState(pathname.includes(ScreenPaths.DailyCareLog));

  useEffect(() => {
    if (open && isTouch && isDailyCareLogApp) {
      setTimeout(() => {
        setOpen(false);
      }, 1500);
    }
  }, [open, isTouch, isDailyCareLogApp]);

  return (
    <MUITooltip
      disableTouchListener
      open={isDailyCareLogApp && isTouch ? open : undefined}
      defaultValue={undefined}
      onClick={isDailyCareLogApp && isTouch ? () => setOpen(!open) : undefined}
      placement="bottom"
      arrow
      {...rest}
    >
      {notAllowedCursor ? (
        <Box
          component="span"
          sx={sx}
          className={className}
          style={{
            pointerEvents: notAllowedCursor ? 'all' : undefined,
            cursor: notAllowedCursor ? 'not-allowed' : undefined,
            ...rest.style,
          }}
        >
          {children}
        </Box>
      ) : (
        children
      )}
    </MUITooltip>
  );
}

// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------
// -----------------------------------------------------------------------------

export interface TooltipIfProps extends TooltipProps {
  condition: boolean | undefined;
}

/** Renders the given content(children) with a tooltip when condition is met. Renders only the content otherwise. */
Tooltip.If = function TooltipIf({children, condition = false, ...rest}: TooltipIfProps) {
  if (!condition) return <>{children}</>;

  return <Tooltip {...rest}>{children}</Tooltip>;
};

Tooltip.NotAllowedIf = function TooltipNotAllowedIf({children, ...rest}: TooltipIfProps) {
  return (
    <Tooltip.If notAllowedCursor={true} {...rest}>
      {children}
    </Tooltip.If>
  );
};
